import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import type * as models from '../../models'

export const DOC = gql`
  fragment FragmentMosaicPageWidgetRendering on MosaicWidgetRendering {
    alias
    id
    payload
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentMosaicPageWidgetRenderingFragment,
  models.widget.Preview
>({
  // NOTE: Eslint disable turned on because of eslint error for payload argument
  // that is type of any
  /* eslint-disable @typescript-eslint/no-unsafe-argument */
  alias: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.common.Aliased.isAliased,
    { warnOnly: true },
  ),
  content: ({ payload }) => JSON.parse(payload)?.content,
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.mosaic.Widget.Id.assertIsId,
    { warnOnly: true },
  ),
  name: ({ payload }) => JSON.parse(payload)?.name,
  type: ({ payload }) => JSON.parse(payload)?.type,
  /* eslint-enable @typescript-eslint/no-unsafe-argument */
})
